import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";

import { useDispatch, useSelector } from "react-redux";

import { selectPagination } from "../../modules/Auth/_redux/authRedux";
import { CountryTab } from "./CountryTab";
import { useLocation } from "react-router-dom";
import {
  fetchCountry,
  setPermissionAddress,
  setPermissionCountry,
  setPermissionLocationMaster,
} from "./locationSlice";
import { AddressTypeTab } from "./AddressTypeTab";
import { LocationMasterTab } from "./LocationMasterTab";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
import { checkMenu } from "../../utility";

export const LocationRelatedPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [active, setActive] = useState("");
  const paginationSet = useSelector(selectPagination);
  const [list, setList] = useState(null);
  const dataMenuTab = useSelector(selectMenuTab);

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchMenuTab({
          menu_url: "/master/location/country-master",
        })
      );
      await dispatch(
        fetchCountry({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      setActive(data[0]);

      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Country Master") {
          return dispatch(setPermissionCountry(item.permissions));
        }
        if (item.menu_name === "Address Type Master") {
          return dispatch(setPermissionAddress(item.permissions));
        }
        if (item.menu_name === "Location Master") {
          return dispatch(setPermissionLocationMaster(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  return (
    <>
      {list && (
        <div>
          <Tabs id="uncontrolled-tab-example" onSelect={(e) => setActive(e)}>
            {checkMenu(list, "Country Master") && (
              <Tab eventKey="Country Master" title="Country Master">
                <CountryTab />
              </Tab>
            )}
            {checkMenu(list, "Address Type Master") && (
              <Tab eventKey="Address Type Master" title="Address Type Master">
                <AddressTypeTab />
              </Tab>
            )}
            {checkMenu(list, "Location Master") && (
              <Tab eventKey="Location Master" title="Location Master">
                <LocationMasterTab />
              </Tab>
            )}
          </Tabs>
        </div>
      )}
    </>
  );
};
